import axios from "axios"
import { default as store } from "@/script/storage"
import { global, renderAlertMessage } from "@/script/helper"

const host = "https://apiv2.lunati.cc"
//const host = "http://localhost:5006"

const apiRemote = axios.create({
	baseURL: `${host}/tcf`,
})

const ENDPOINTS = {
	POST_LOCATION: (mapID) => `/location/${mapID}`,
	GET_LOCATION: (mapID) => `/location/${mapID}`,
	DELETE_MARKER: (markerUID) => `/marker/${markerUID}`,
	GET_USER: "/user",
}

// Request Interceptor
apiRemote.interceptors.request.use((request) => {
	const token = store.getters.token

	if (token) {
		request.headers.Authorization = `Bearer ${token}`
	}

	return request
})

// Response Interceptor
apiRemote.interceptors.response.use(
	(response) => {
		const { token } = response?.headers ?? {}

		if (token !== undefined) {
			store.commit("setJwt", token)
		}

		return response
	},
	async (error) => {
		const { response } = error ?? {}
		const { status } = response

		if (status === 401 && store.getters.isLoggedIn) {
			await store.dispatch("invalidateUser")
			global.message?.error(
				"Discord Auth::session expired or manually de-authorized",
				{
					render: renderAlertMessage,
					closable: true,
					duration: 0,
				}
			)
		}
	}
)

export async function getLocationsForMap(mapID) {
	return apiRemote.get(ENDPOINTS.GET_LOCATION(mapID)).then((response) => {
		return response?.data?.locations
	})
}

export async function removeMarker(markerUID) {
	return apiRemote
		.delete(ENDPOINTS.DELETE_MARKER(markerUID))
		.then((response) => {
			return response?.status === 204
		})
}

export async function getUser() {
	return apiRemote.get(ENDPOINTS.GET_USER).then((response) => {
		return response?.status === 204
	})
}

export async function uploadLocation(mapID, locationData) {
	return apiRemote
		.post(ENDPOINTS.POST_LOCATION(mapID), locationData)
		.then((response) => {
			return response?.data?.location
		})
}
